// extracted by mini-css-extract-plugin
module.exports = {"center":"errorPage_center__1C6g8","card":"errorPage_card__1sA04","bottom":"errorPage_bottom__2gqJE"};